import script from "./SubMenusHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubMenusHelp.vue?vue&type=script&setup=true&lang=ts"

import "./SubMenusHelp.vue?vue&type=style&index=0&id=1f9bdc26&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9bdc26"]])

export default __exports__